import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "auth/context";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import { BrowserRouter as Router } from "react-router-dom";
import { ScrollToTop } from "utils/ScrollToTop";

if (process.env.NODE_ENV === "production") {
  disableReactDevTools();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </React.StrictMode>
);
